import { render, staticRenderFns } from "./manageStockModal.vue?vue&type=template&id=38ebb3ae&"
import script from "./manageStockModal.vue?vue&type=script&lang=js&"
export * from "./manageStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports